export const FREE_ACCOUNT_ERROR_CODE = 'FREE_ACCOUNT_ACCESS_RESTRICTED';
export const ACCOUNT_ACCESS_ROUTE = '/#/account-access';

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch (error) {
    return null;
  }
}

export function getAccountAccessPolicy() {
  const user = getStoredUser();
  return user && user.access_policy ? user.access_policy : null;
}

export function isFreeAccountRestricted() {
  const policy = getAccountAccessPolicy();
  return Boolean(policy && policy.restricted);
}

export function storeAccountAccessPolicy(policy) {
  if (!policy) return;

  const user = getStoredUser() || {};
  user.access_policy = policy;
  localStorage.setItem('user', JSON.stringify(user));
}

/**
 * "Legacy App Access" entitlement.
 *
 * Retired apps (GrooveMember, GrooveBlog, GrooveVideo, GrooveWebinar) keep an
 * in-app sunset notice that blocks new top-level creation. Accounts that hold
 * the Legacy App Access grant keep working in those apps, so the notice must
 * not fire for them.
 *
 * The grant is resolved server-side and cached on the stored user, so the
 * frontend never has to hardcode an account.
 */
export function hasLegacyAppAccess() {
  const user = getStoredUser();
  if (!user) return false;

  if (user.legacy_app_access) return true;

  const policy = user.access_policy;
  return Boolean(policy && policy.legacy_app_access);
}

/**
 * Legacy Admin: an administrator who may reach the legacy apps even without the
 * Legacy App Access grant. The legacy card labels this state and still links
 * through, rather than leaving the admin at a dead end.
 */
export function isLegacyAdmin() {
  const user = getStoredUser();
  if (!user) return false;

  if (user.legacy_admin) return true;

  const policy = user.access_policy;
  return Boolean(policy && policy.legacy_admin);
}

/**
 * True when the account may work inside a retired app, either because it holds
 * the grant or because it is a Legacy Admin.
 */
export function canUseLegacyApps() {
  return hasLegacyAppAccess() || isLegacyAdmin();
}

export function isAccountAccessDenial(error) {
  const response = error && error.response;
  return Boolean(
    response &&
    response.status === 403 &&
    response.data &&
    response.data.code === FREE_ACCOUNT_ERROR_CODE
  );
}

export function redirectToAccountAccess(policy) {
  if (policy) storeAccountAccessPolicy(policy);

  if (window.location.hash === '#/account-access') return;

  window.location.replace(`${window.location.origin}${ACCOUNT_ACCESS_ROUTE}`);
}

export function handleAccountAccessDenial(error) {
  if (!isAccountAccessDenial(error)) return false;

  redirectToAccountAccess(error.response.data.access_policy);
  return true;
}
